/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Categories_TitleInputs */

const en_admin_categories_title = /** @type {(inputs: Admin_Categories_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Categories`)
};

const zh_admin_categories_title = /** @type {(inputs: Admin_Categories_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`分类管理`)
};

/**
* | output |
* | --- |
* | "Categories" |
*
* @param {Admin_Categories_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_categories_title = /** @type {((inputs?: Admin_Categories_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Categories_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_categories_title(inputs)
	return zh_admin_categories_title(inputs)
});
export { admin_categories_title as "admin.categories.title" }